"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDownloader = exports.DownloaderProvider = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("react");
const ToastContext_1 = require("context/ToastContext");
const useLocale_1 = require("hooks/useLocale");
const CsvHelper_1 = require("utils/CsvHelper");
const socket_1 = require("utils/socket");
const initialState = {
    isDownloadInProcess: false,
    activeQueue: 0
};
const defaultUpdate = () => initialState;
const DownloaderContext = (0, react_1.createContext)({
    state: initialState,
    setState: defaultUpdate
});
// PROVIDER
const DownloaderProvider = (props) => {
    const [state, setState] = (0, react_1.useState)(initialState);
    return react_1.default.createElement(DownloaderContext.Provider, { value: { state, setState }, ...props });
};
exports.DownloaderProvider = DownloaderProvider;
// MUTATION
const useDownloader = () => {
    const { state, setState } = (0, react_1.useContext)(DownloaderContext);
    const { addToast } = (0, ToastContext_1.useToastContext)();
    const { setBothLocale } = (0, useLocale_1.useLocale)();
    const setIsDownloadInProcess = (inProcess) => {
        setState((draft) => ({ ...draft, isDownloadInProcess: inProcess }));
    };
    const setActiveQueue = (type) => {
        setState((draft) => ({
            ...draft,
            activeQueue: type == 'increment' ? draft.activeQueue + 1 : draft.activeQueue - 1
        }));
    };
    const listener = react_1.default.useMemo(() => new socket_1.SocketListener(), []);
    const setupSocket = () => {
        listener.register({
            name: socket_1.SocketChannels.backgroundJobProgress(),
            callback: (data) => {
                addToast({
                    title: setBothLocale('Preparing file completed!'),
                    msg: setBothLocale('CSV has been prepared and the file will be downloaded automatically'),
                    type: 'success'
                });
                (0, CsvHelper_1.downloadExportCSV)(data?.object?.file);
                setIsDownloadInProcess(false);
                setActiveQueue('decrement');
            }
        });
    };
    (0, react_2.useEffect)(() => {
        if (state.activeQueue == 0) {
            listener.unregister();
        }
    }, [state.activeQueue, listener]);
    return {
        isDownloadInProcess: state?.isDownloadInProcess,
        setIsDownloadInProcess,
        setupSocket,
        setActiveQueue
    };
};
exports.useDownloader = useDownloader;
